import parseCookieString from './utils/parseCookieString';

const parseCookie = (name: string, cookiesString: string): string | null => {
  const cookieValue = parseCookieString(name, cookiesString);
  return cookieValue || null;
};

export default parseCookie;
